var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoGerenciamentoArquivo01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arquivos_importados",
    transform: "translate(7 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arquivos_importados-2",
    d: "M8.2,29.2c0,0.8-0.6,1.4-1.4,1.4h-6c-3,0-5.5-2.5-5.5-5.5V1c0-3,2.5-5.5,5.5-5.5h16.8 c3,0,5.5,2.5,5.5,5.5V14c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4l0,0V1c0-1.5-1.2-2.7-2.7-2.7H0.8C-0.7-1.8-2-0.6-2,1V25 c0,1.5,1.2,2.7,2.7,2.7h6C7.5,27.8,8.2,28.4,8.2,29.2z M16.2,3.7H2.1c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4h14.1 c0.8,0,1.4-0.6,1.4-1.4S17,3.7,16.2,3.7L16.2,3.7z M17.6,10.5c0-0.8-0.6-1.4-1.4-1.4H2.1c-0.8,0-1.4,0.6-1.4,1.4 c0,0.8,0.6,1.4,1.4,1.4h14.1C17,11.9,17.6,11.3,17.6,10.5L17.6,10.5z M2.1,14.6c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4h7.2 c0.8,0,1.4-0.6,1.4-1.4c0-0.8-0.6-1.4-1.4-1.4l0,0H2.1z M26.5,24.7c0,0.1-0.2,0.3-0.3,0.4c-0.9,1.1-1.9,2.2-3,3.1 c-1.6,1.4-3.7,2.2-5.9,2.3c-2.2-0.1-4.2-0.9-5.9-2.3c-1.1-0.9-2.1-2-3-3.1c-0.1-0.1-0.3-0.4-0.3-0.4c-0.3-0.5-0.3-1.1,0-1.6 c0-0.1,0.2-0.3,0.3-0.4c0.9-1.2,1.9-2.2,3-3.1c1.6-1.4,3.7-2.2,5.9-2.3c2.2,0.1,4.2,0.9,5.9,2.3c1.1,0.9,2.1,2,3,3.1 c0.1,0.1,0.3,0.4,0.3,0.4C26.8,23.6,26.8,24.2,26.5,24.7L26.5,24.7z M23.6,23.9c-2.2-2.6-4.3-3.9-6.3-3.9s-4.2,1.3-6.3,3.9 c2.2,2.6,4.3,3.9,6.3,3.9S21.4,26.5,23.6,23.9L23.6,23.9z M17.3,21.3c-1.4,0-2.6,1.2-2.6,2.6s1.2,2.6,2.6,2.6s2.6-1.2,2.6-2.6 C19.9,22.4,18.8,21.3,17.3,21.3L17.3,21.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGerenciamentoArquivo01);
export default __webpack_public_path__ + "static/media/ico-gerenciamento-arquivo-01.7625e8a287a559da42de4105af09331b.svg";
export { ForwardRef as ReactComponent };